<p-dialog
  #fastVariacaoProd
  [modal]="true"
  [visible]="true"
  (visibleChange)="dialogRef.close()"
  [breakpoints]="{ '1199px': '75vw', '575px': '90vw' }"
  [maximizable]="true"
  [closable]="true"
  [responsive]="true"
  [closeOnEscape]="false"
  [dismissableMask]="false"
>
  <ng-template pTemplate="header">
    <div class="flex aling-items-center">
      <span class="font-light fs-normal">Adicionar variação</span>
      <i class="mdi mdi-vector-difference-ba ml-2 text-primary"></i>
    </div>
  </ng-template>
  <div class="row mt-2">
    <div class="col-md-12 mb-2">
      <span class="p-float-label">
        <input
          id="inputtext-descricao"
          class="input-filters"
          pInputText
          [formControl]="form.get('descricao')"
          type="text"
          (blur)="checarExisteNome()"
          autocomplete="off"
        />
        <label for="inputtext-descricao">Descrição *</label>
      </span>
      <small
        class="p-error"
        *ngIf="form.get('descricao').hasError('required')"
        [innerHTML]="displayMessages.descricao.required"
      >
      </small>
      <small
        class="p-error"
        *ngIf="form.get('descricao').hasError('maxlength')"
        [innerHTML]="displayMessages.descricao.maxlength"
      >
      </small>
      <small
        class="p-error"
        *ngIf="form.get('descricao').hasError('isEmptyValue')"
        [innerHTML]="displayMessages.descricao.isEmptyValue"
      >
      </small>
      <small
        class="p-error"
        *ngIf="form.get('descricao').hasError('repeated')"
        [innerHTML]="displayMessages.descricao.repeated"
      >
      </small>
    </div>
    <div class="col-md-11 mb-2">
      <span class="p-float-label">
        <input
          id="inputtext-descricao_item"
          class="input-filters"
          pInputText
          (keyup)="enterAdd($event)"
          [formControl]="form.get('descricao_item')"
          type="text"
          [value]="form.get('descricao_item').value"
          autocomplete="off"
        />
        <label for="inputtext-descricao_item">Variação</label>
      </span>
      <mat-hint
        class="fs-xsmall"
        *ngIf="!form.get('descricao_item').invalid && itens.value.length === 0"
      >
        Obs: Adicione pelo menos um item pra variação!
      </mat-hint>
      <small
        class="p-error"
        *ngIf="form.get('descricao_item').hasError('required')"
        [innerHTML]="displayMessages.descricao_item.required"
      >
      </small>
      <small
        class="p-error"
        *ngIf="form.get('descricao_item').hasError('maxlength')"
        [innerHTML]="displayMessages.descricao_item.maxlength"
      >
      </small>
      <small
        class="p-error"
        *ngIf="form.get('descricao_item').hasError('isEmptyValue')"
        [innerHTML]="displayMessages.descricao_item.isEmptyValue"
      >
      </small>
    </div>
    <div class="btn-add">
      <button
        pButton
        pRipple
        [disabled]="!form.get('descricao_item').value"
        (click)="addItem()"
        pTooltip="Adicionar item"
        icon="pi pi-plus"
        class="p-button-primary p-button-raised p-button-rounded p-button-sm"
      ></button>
    </div>
  </div>
  <div class="table-container" *ngIf="itens.value.length >= 1">
    <table mat-table [dataSource]="itens.value" class="w-100">
      <ng-container matColumnDef="index">
        <th mat-header-cell *matHeaderCellDef>Nº</th>
        <td mat-cell *matCellDef="let element">{{ element.index }}</td>
      </ng-container>
      <ng-container matColumnDef="descricao">
        <th mat-header-cell *matHeaderCellDef>Descrição</th>
        <td mat-cell *matCellDef="let element">{{ element.descricao }}</td>
      </ng-container>

      <ng-container matColumnDef="delete">
        <th mat-header-cell *matHeaderCellDef>
          <button
            type="button"
            pButton
            pRipple
            (click)="rmTodos()"
            [disabled]="itens.value.length === 0"
            icon="pi pi-trash"
            class="button-radius p-button-rounded p-button-text p-button-danger"
          ></button>
        </th>
        <td mat-cell *matCellDef="let element">
          <button
            type="button"
            pButton
            pRipple
            icon="pi pi-trash"
            (click)="rmItem(element)"
            class="button-radius p-button-rounded p-button-text p-button-danger"
          ></button>
        </td>
      </ng-container>

      <tr mat-header-row *matHeaderRowDef="displayedColumns"></tr>
      <tr mat-row *matRowDef="let row; columns: displayedColumns"></tr>
    </table>
  </div>
  <ng-template pTemplate="footer">
    <div class="width-100 mb-3 flex align-items-center justify-content-between">
      <button
        pButton
        pRipple
        severity="danger"
        text
        rounded
        [disabled]="loading"
        (click)="dialogRef.close()"
        label="Cancelar"
        icon="pi pi-fw pi-times-circle"
        iconPos="right"
      ></button>
      <button
        pButton
        pRipple
        severity="success"
        outlined
        rounded
        label="Salvar"
        icon="pi pi-fw pi-save"
        iconPos="right"
        (click)="submit()"
        [disabled]="loading || !form.valid || itens.value.length === 0"
      ></button>
    </div>
  </ng-template>
</p-dialog>
